import merge from 'lodash/merge'
import baseButtonStyles from '../BaseButton/BaseButton.styles'
import parseTypography from '@converdy/styles/parsers/parse-typography'
import { parseResponsiveProperty } from '@converdy/styles'


export default function headerStyles({
  background,
  typography = {},
  backdrop,
  closeIcon
}) {
  
  let jss = {
    '& .side-panel': {
      background,
    },
    '& .side-panel .navigation': parseTypography(typography),
    '& .side-panel .close': {
      'color': closeIcon
    }
  }

  return jss
}
